import { render } from "./InputAddress.vue?vue&type=template&id=284f89c7&scoped=true"
import script from "./InputAddress.vue?vue&type=script&lang=js"
export * from "./InputAddress.vue?vue&type=script&lang=js"

import "./InputAddress.vue?vue&type=style&index=0&id=284f89c7&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-284f89c7"]])

export default __exports__